import { racaEnMessages } from './racaEnMessages';
import { racaRuMessages } from './racaRuMessages';

export const RACAMessages = {
    ru: racaRuMessages,
    en: racaEnMessages,
}
